module.exports = __webpack_public_path__ + "img/email (1).f779dcfc.svg";